import React from 'react';
import { Text,StyleSheet } from 'react-native';
import Theme from '../theme';

interface IProps {
  t: (str: string) => string;
}

export const InfluencerLearnMorePartThree = ({ t }: IProps) => {
  return (
    <>
      <Text style={styles.normalText}>
        {t('bookings:whatYouNeedForWorkout')}
      </Text>
    </>
  );
};

const styles = StyleSheet.create({
  normalText: {
    ...Theme.textStyle.bodyCopyReg,
  },
  castingText: {
    ...Theme.textStyle.bodyCopyBold,
    color: Theme.PRIMARY,
    textAlign: 'center',
  },
});
